module.exports = __webpack_public_path__ + "static/img/yd-bg3.6cb04f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-bg3.jpg
// module id = pQrq
// module chunks = 0